module.exports = __webpack_public_path__ + "static/media/ManorCafe.dd0c7ed6.png";